import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../../app/redux/hooks';
import { convertToEpoch, currentLocation } from '../../../../../utils/commonFunctions';

export const useNotificationEffectHooks = ({
  data,
  notification,
  allVehicleData,
  isOpen,
  getStartDate,
  getEndDate,
  count,
  typeList,
  urls,
  isXs,
  setSideBarOpen,
  setDatas
}: any) => {
  const [location, setLocation] = useState({ lat: '', lng: '' });
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isXs === true) {
      setSideBarOpen(true);
    } else {
      setSideBarOpen(false);
    }
  }, [isXs]);

  useEffect(() => {
    if (data.length > 0) {
      setDatas(data);
    }
    if (notification.data.length > 0) {
      setDatas(notification.data);
    }
  }, [data, notification.data]);

  useEffect(() => {
    return () => {
      setDatas([]);
    };
  }, [typeList]);

  useEffect(() => {
    dispatch(urls.getMapDetails({ arg1: 'total', arg2: false }));
    currentLocation()
      .then((res: any) => {
        setLocation({ lat: res?.coords?.latitude, lng: res?.coords?.longitude });
      })
      .catch((error: any) => {
        return;
      });

    return () => {
      dispatch(urls.clearNotification());
    };
  }, []);

  useEffect(() => {
    if (isOpen === 'notification') {
      dispatch(
        urls.getNotification({
          count: count,
          events: typeList,
          startdate: convertToEpoch(getStartDate),
          enddate: convertToEpoch(getEndDate)
        })
      );
    }
  }, [isOpen]);

  useEffect(() => {
    if (allVehicleData?.length > 0) {
      dispatch(urls.center(allVehicleData));
      dispatch(urls.zoom(allVehicleData));
    }
  }, [location, allVehicleData]);
};
